module.exports = __webpack_public_path__ + "img/组7@2x.93d0c0ed.png";